import { Box } from '@mantine/core';

type Props = {
  top?: number | string;
};

export function SiestaBusyGlow({ top = '50%' }: Props) {
  const topValue = typeof top === 'number' ? `${top}%` : top;

  return (
    <Box pos="absolute" left={0} top={0} bottom={0} style={{ width: 200, overflow: 'visible' }}>
      <Box
        pos="absolute"
        left={-380}
        style={{
          top: topValue,
          transform: 'translateY(-50%)',
          transition: 'top 0.3s ease-out',
          width: 500,
          height: 800,
          background:
            'radial-gradient(ellipse 250px 400px at 50% 50%, rgba(253, 110, 61, 0.6) 0%, rgba(253, 110, 61, 0.3) 50%, transparent 100%)',
          pointerEvents: 'none',
        }}
      />
    </Box>
  );
}
